import claude from '@/assets/app-logos/claude-color.svg';
import claudeCode from '@/assets/app-logos/claude-code-color.svg';
import cursor from '@/assets/app-logos/cursor.svg';
import openai from '@/assets/app-logos/openai.svg';
import type { AiAppId } from '@/features/ai-apps/types';

// Official marks from @lobehub/icons-static-svg 1.95.1 (MIT).
export const AI_APP_LOGOS: Record<
  AiAppId,
  { src: string; monochrome: boolean }
> = {
  claude: { src: claude, monochrome: false },
  chatgpt: { src: openai, monochrome: true },
  'claude-code': { src: claudeCode, monochrome: false },
  cursor: { src: cursor, monochrome: true },
};

export const AI_APP_SUBTITLES: Record<AiAppId, string> = {
  claude: 'Web, desktop and mobile',
  chatgpt: 'Business, Enterprise and Edu',
  'claude-code': 'In your terminal',
  cursor: 'In your editor',
};
